<script>
    /**
     * Two months view calendar, shows two months at a time
     * @requires ./BaseCalendar.vue
     * @displayName TwoMonthsViewCalendar
     */
    import BaseCalendar from './BaseCalendar.vue'

    export default {
        name: 'TwoMonthsViewCalendar',
        extends: BaseCalendar,
        methods: {
            handleNextMonths() {
                if (this.viewIndx >= this.calendarView.length - 3) {
                    this.viewIndx = 0
                } else {
                    this.viewIndx = this.viewIndx + 2
                }
            },
            handlePrevMonths() {
                if (this.viewIndx <= 1) {
                    this.viewIndx = this.calendarView.length - 3
                } else {
                    this.viewIndx = this.viewIndx - 2
                }
            },
            isCurrentMonths(indx) {
                return indx === this.viewIndx
            },

            isNextMonths(indx) {
                let currentLen = this.calendarView.length

                if (indx === this.viewIndx + 1) return true
                if (this.viewIndx === currentLen - 1 && indx === 0) return true

                return false
            },

            isNextHiddenMonths(indx) {
                let currentLen = this.calendarView.length

                if (indx === this.viewIndx + 2) return true
                if (this.viewIndx === currentLen - 2 && indx === 0) return true
                if (this.viewIndx === currentLen - 1 && indx === 1) return true

                return false
            },

            isPrevHiddenMonths(indx) {
                let currentLen = this.calendarView.length

                if (indx === this.viewIndx - 2) return true
                if (indx === currentLen - 2 && this.viewIndx === 0) return true
                if (indx === currentLen - 1 && this.viewIndx === 1) return true

                return false
            },

            isHiddenMonths(indx) {
                if (
                    this.isNextMonths(indx) ||
                    this.isNextHiddenMonths(indx) ||
                    this.isPrevHiddenMonths(indx) ||
                    this.isCurrentMonths(indx)
                )
                    return false

                return true
            }
        },

        computed: {
            monthsClass: (self) => (indx) => {
                if (self.isHiddenMonths(indx)) return { 'two-view-hidden-months': true }
                if (self.isCurrentMonths(indx)) return { 'two-view-curr-months': true }
                if (self.isNextMonths(indx)) return { 'two-view-next-months': true }
                if (self.isPrevHiddenMonths(indx))
                    return { 'two-view-prev-hidden-months': true }
                if (self.isNextHiddenMonths(indx))
                    return { 'two-view-next-hidden-months': true }
            }
        }
    }
</script>
<style lang="scss" scoped>
    $tablet: 800px;
    $medLaptop: 1360px;
    @media screen and (max-width: $medLaptop) {
        .two-view-prev-hidden-months.month {
            margin-left: -460px !important;
        }
    }
    @media screen and (max-width: $tablet) {
        .two-view-prev-hidden-months.month {
            margin-left: -357px !important;
        }
    }
    .month-view {
        width: 520px !important;
    }
    .two-view-hidden-months {
        display: none !important;
    }

    .two-view-prev-hidden-months {
        order: 1;
    }

    .two-view-curr-months {
        order: 2;
    }

    .two-view-next-months {
        order: 3;
    }
    .two-view-next-hidden-months {
        order: 4;
    }

    .two-view-prev-hidden-months.month {
        margin-left: -473px;

        .month-label {
            opacity: 0.1;
        }

        .month-view {
            opacity: 0.1;

            .header {
                overflow: hidden !important;
            }
            .dates {
                overflow: hidden !important;
            }
        }
    }

    .two-view-next-hidden-months.month {
        .month-label {
            opacity: 0.1;
        }

        .month-view {
            opacity: 0.1;

            .header {
                overflow: hidden !important;
            }
            .dates {
                overflow: hidden !important;
            }
        }
    }
</style>
